/**
 * @desc: 渠道查询
 * @created: 2020/6/1
 * @author: Colorfule
 * @version: v1.0
 */

import request from '@/plugins/http';

// 获取列表数据
export const getListData = params => {
  return request.get('/feedback/list', params)
}

// 获取详情
export const geFeedbackDetails = params => {
  return request.get('/feedback/detail', params)
}

// 转移发行
export const transferFeedback = data => {
  return request.post('/feedback/transfer', data, { json: true })
}


// 转移发行 拒绝批复 
export const feedbackInfo = params => {
  return request.get('/feedback/feedbackInfo', params)
}

// 转移复核 
export const transferCheck = params => {
  return request.get('/feedback/transferCheck', params)
}